exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#dict-corpora {\r\n    height: 100% !important;\r\n    width: 100% !important;\r\n    /*border: 1px solid #dcdcdc !important;*/\r\n    border-radius: 2px;\r\n    padding-left: 0 !important;\r\n    padding-right: 0 !important;\r\n}", ""]);

